import { render, staticRenderFns } from "./EodTemplateQuestions.vue?vue&type=template&id=061f324a&scoped=true&"
import script from "./EodTemplateQuestions.vue?vue&type=script&lang=js&"
export * from "./EodTemplateQuestions.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tailwind.min.css?vue&type=style&index=0&id=061f324a&prod&scoped=true&lang=css&"
import style1 from "./EodTemplateQuestions.vue?vue&type=style&index=1&id=061f324a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f324a",
  null
  
)

export default component.exports